import APIService from '../api';

const CURRENT_COUNTRY_STORAGE = '@twism:current-country';

export default class InternationalizationService extends APIService {
  getCountries(data?: { params: Record<string, string> }) {
    return this.get('/location/country', data || {});
  }

  async getCurrentCountry(data?: { params: Record<string, string> }) {
    const storageCurrentCountry = localStorage.getItem(CURRENT_COUNTRY_STORAGE);
    if (storageCurrentCountry)
      return { data: JSON.parse(storageCurrentCountry) };

    const response = await this.get('/v2/location/current-country', data || {});
    if (response) {
      localStorage.setItem(
        CURRENT_COUNTRY_STORAGE,
        JSON.stringify(response.data)
      );
    }
    return response;
  }

  reportNewIntegration(data: any) {
    return this.post('/report', data);
  }

  reportNewIntegrationWithoutUser(data: any) {
    return this.post('/report/without-user', data);
  }

  getCountryIntegrations(country: string) {
    return this.get('/integration', {
      params: {
        filters: `country.name:${country}`,
        limit: 1000
      }
    });
  }
}
